<template>
    <div class="page">
        <img class="bn" src="https://cdncos.aigupiao.com/assets/app/toUser.png" @click.stop.prevent="jumpUrl" />
        <img class="close" src="https://cdncos.aigupiao.com/assets/app/tuUserClose.png" @click.stop.prevent="closePage" />
    </div>
</template>
<script>
export default {
    name: "page_2_fsls",
    data() {
        return {

        }
    },
    props: {
        url: {
            type: String,
            default: ""
        }
    },
    methods: {
        jumpUrl() {
            // followup_url
            this.$srH5CallNativeMethodApp('jump_jufeng_page', {
                url: this.url
            })
            this.closePage();
        },
        closePage() {
            this.$parent.isShowSatiCard = false;
        }
    }
}
</script>
<style scoped lang="scss">
.page {
    width: 100%;
    min-height: 100vh;
    background-color: #7B7D7F;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999999;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .bn {
        width: 80vw;
        height: auto;
        display: block;
        // margin: 50% auto 0;
    }

    .close {
        width: 30px;
        height: 30px;
        margin-top: 30px;// auto
        display: block;
    }
}
</style>